var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRotate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 17"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 11,
  y: 6,
  fill: "#010101",
  rx: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5 3c2.5 0 6.5 0 6.5 5M6 1 4 3l2 2"
})));
export default SvgRotate;